import Layout from 'layout';
import MidtermReviewFormCreate from 'features/MidtermReview/pages/Create';
import { LayoutProvider } from '../layout/context/layoutcontext';

function MidtermReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <MidtermReviewFormCreate />
      </Layout>
    </LayoutProvider>
  );
}

export default MidtermReviewFormCreatePage;
